import plugins from './plugins/config';
import GlobalComponents from './components/globals/globals';
import vendorDependencies from './vendor';
import GlobalDirectives from './directives';
import GlobalFilters from './filters';

export default (Vue) => {
  Vue.config.productionTip = false;
  const deps = vendorDependencies(Vue);
  Vue.use(plugins);
  Vue.use(GlobalComponents);
  Vue.use(GlobalDirectives);
  Vue.use(GlobalFilters);

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line
    const debug = require('./services/debugBuilder');
    debug.default();
  }

  return deps;
};
